import { Component } from '@angular/core';

@Component({
	selector: 'ae-if-has-value-default-else',
	templateUrl: './if-has-value-default-else.component.html',
	styleUrls: ['./if-has-value-default-else.component.scss'],
})
export class IfHasValueDefaultElseComponent {}
